import{a as i}from"./chunk-EI7MMDWY.js";function c(e){return e.includes("drive.google.com")?e.replace(/file\/d\/(.+?)\/view.*/g,"uc?id=$1"):e}i(c,"directLink");export{c as a};
